<template>
    <div>
        <buttonlist @reflash="reflash" ref="SetBtn"></buttonlist>

        <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
            <el-tab-pane :label="$t('getapi[6833]')" name="0">
                <vxe-table
                        :data="dataSet"
                        :highlight-current-row="true"
                        :auto-resize="true"
                        :height="tableHeight"
                        resizable
                        show-overflow="tooltip"
                        header-row-class-name="headerclass"
                        border
                        size="mini"
                        style="width: 100%; margin-top:5px"
                >
                    <vxe-table-column show-footer-overflow field="SysID" :title="$t('getapi[6834]')" align="right" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="SysNM" :title="$t('getapi[6835]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Lv1SN" :title="$t('getapi[6838]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="LvCode" :title="$t('getapi[6839]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="LvNM" :title="$t('getapi[6840]')" width="120"></vxe-table-column>
                </vxe-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6843]')" name="1">
                <vxe-table
                        :data="dataSet1"
                        :highlight-current-row="true"
                        :auto-resize="true"
                        :height="tableHeight"
                        resizable
                        show-overflow="tooltip"
                        header-row-class-name="headerclass"
                        border
                        size="mini"
                        style="width: 100%; margin-top:5px"
                >
                    <vxe-table-column show-footer-overflow field="SysID" :title="$t('getapi[6834]')" align="right" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="SysNM" :title="$t('getapi[6835]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="FrmID" :title="$t('getapi[6836]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="FrmNM" :title="$t('getapi[6837]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Lv2SN" :title="$t('getapi[6838]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="LvCode" :title="$t('getapi[6839]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="LvNM" :title="$t('getapi[6840]')" width="120"></vxe-table-column>
                </vxe-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6845]')" name="2">
                <vxe-table
                        :data="dataSet2"
                        :highlight-current-row="true"
                        :auto-resize="true"
                        :height="tableHeight"
                        resizable
                        show-overflow="tooltip"
                        header-row-class-name="headerclass"
                        border
                        size="mini"
                        style="width: 100%; margin-top:5px"
                >
                    <vxe-table-column show-footer-overflow field="SysID" :title="$t('getapi[6834]')" align="right" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="SysNM" :title="$t('getapi[6835]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="FrmID" :title="$t('getapi[6836]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="FrmNM" :title="$t('getapi[6837]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="ModID" :title="$t('getapi[6841]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="ModNM" :title="$t('getapi[6842]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Lv3SN" :title="$t('getapi[6838]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="LvCode" :title="$t('getapi[6839]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="LvNM" :title="$t('getapi[6840]')" width="120"></vxe-table-column>
                </vxe-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6844]')" name="3">
                <vxe-table
                        :data="dataSet3"
                        :highlight-current-row="true"
                        :auto-resize="true"
                        :height="tableHeight"
                        resizable
                        show-overflow="tooltip"
                        header-row-class-name="headerclass"
                        border
                        size="mini"
                        style="width: 100%; margin-top:5px"
                >
                    <vxe-table-column show-footer-overflow field="SysID" :title="$t('getapi[6834]')" align="right" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="SysNM" :title="$t('getapi[6835]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="FrmID" :title="$t('getapi[6836]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="FrmNM" :title="$t('getapi[6837]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="ModID" :title="$t('getapi[6841]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="ModNM" :title="$t('getapi[6842]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Lv4SN" :title="$t('getapi[6838]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="LvCode" :title="$t('getapi[6839]')" width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="LvNM" :title="$t('getapi[6840]')" width="120"></vxe-table-column>
                </vxe-table>
            </el-tab-pane>
        </el-tabs>
    </div>


</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'dblv',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight1
            }
        },
        data() {
            return {
                SelectIndex: 0, //当前页面
                dataSet: [], // 主表数据
                dataSet1:[],
                dataSet2:[],
                dataSet3:[],
                loading: false,
            };
        },
        mounted: function() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.getView();
            that.authority();
        },
        methods: {
            authority() {
                let that = this;
                that.$refs.SetBtn.SetButtonEnable('refresh');
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                that.$http.urlpost('/Sys/Authority/GetDBLV', '', function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.LV1;
                        that.dataSet1 = res.DataContent.LV2;
                        that.dataSet2 = res.DataContent.LV3;
                        that.dataSet3 = res.DataContent.LV4;
                        that.loading = false;
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
            },
        }
    };
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	overflow-x: auto;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
			margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
    }
}
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
